import µUtils from '../libs/utils'
import http from '@/libs/http'

/*
	NOTICE:
	- every action starts with an underscore
*/

const actions: any = {
	//? HUBS
	//? GET ALL HUBS
	async _listAllHubs({ state, dispatch }: any) {
    console.log('VUEX _listAllHubs');
		try {
			const resp = await http.getAuth<any>(`/api/v1/hubs/list`)
			return resp
		} catch (error: any) {
			console.error(error)
			// const msg = error.response?.data?.msg || error.response?.data || error.message
			// µUtils.µ_error(msg)
			return []
		}
	},

	//? HUBS BY PROJECT AND BY LOCATION
	async _listHubsByProject({ state, dispatch }: any, prolocId: string) {
    console.log('VUEX _listHubsByProject', prolocId)
		try {
			const resp = await http.getAuth<any>(`/api/v1/hubs/list/${prolocId}`)
			return resp
		} catch (error: any) {
			console.error(error)
			const msg = error.response?.data?.msg || error.response?.data || error.message
			µUtils.µ_error(msg)
			return []
		}
	},

	//? MODULES
	//? GET ALL MODULES
	async _listAllModules({ state, dispatch }: any) {
		try {
			// const config = await dispatch('_config')
			// const resp = await axios.get(env.apiUrl + `/api/v1/modules/list`, config)
			// return resp.data || []
			const resp = await http.getAuth<any>(`/api/v1/modules/list`)
			return resp
		} catch (error: any) {
			console.error(error)
			// const msg = error.response?.data?.msg || error.response?.data || error.message
			// µUtils.µ_error(msg)
			return []
		}
	},

	async _listModulesByHubsIds({ state, dispatch }: any, data: any) {
		// projectId only for user access check
		try {
			// const config = await dispatch('_config')
			// const headers = { ...config.headers, hubids: data.hubids }
			// // const resp = await axios.get(env.apiUrl + `/api/v1/modules/list/${data.projectId}`, { headers })
			// const resp = await axios.get(env.apiUrl + `/api/v1/modules/list/${data.projectId}`, { headers })
			// // console.log(resp.data);
			// return resp.data || []
			const resp = await http.getAuth<any>(`/api/v1/modules/list/${data.projectId}`, {
				headers: { hubids: data.hubids },
			})
			return resp || []
		} catch (error: any) {
			console.error(error)
			const msg = error.response?.data?.msg || error.response?.data || error.message
			µUtils.µ_error(msg)
			return []
		}
	},

	async _setModulInterval({ state, dispatch }: any, data: any) {
		// projectId only for user access check
		try {
			// const resp = await axios.post(
			// 	env.apiUrl + `/api/v1/modules/setModulInterval/`,
			// 	data,
			// 	await dispatch('_config'),
			// )
			// // console.log(resp.data);
			// // µUtils.µ_success(`Modul updated.`)
			// return resp.data || []
			const resp = await http.postAuth<any>(`/api/v1/modules/setModulInterval/`, data)
			return resp || []
		} catch (error: any) {
			console.error(error)
			const msg = error.response?.data?.msg || error.response?.data || error.message
			µUtils.µ_error(msg)
			return []
		}
	},
	async _setAverageInterval({ state, dispatch }: any, data: any) {
		// projectId only for user access check
		try {
			// const resp = await axios.post(
			// 	env.apiUrl + `/api/v1/modules/setAverageInterval/`,
			// 	data,
			// 	await dispatch('_config'),
			// )
			// console.log(resp.data);
			// µUtils.µ_success('Average time stamp updated.')
			// return resp.data || []
			const resp = await http.postAuth<any>(`/api/v1/modules/setAverageInterval/`, data)
			return resp || []
		} catch (error: any) {
			console.error(error)
			const msg = error.response?.data?.msg || error.response?.data || error.message
			µUtils.µ_error(msg)
			return []
		}
	},

	async _updateHub({ state, dispatch }: any, data: any) {
		try {
			// const config = await dispatch('_config')
			// const headers = { ...config.headers, hubids: data.hubids }
			// const resp = await axios.post(env.apiUrl + `/api/v1/hubs/update`, data, { headers })
			// // console.log(resp.data);
			// await dispatch('_initAdmin', ['hubs', 'allStates'])
			// return resp.data?.msg || []
			const resp = await http.postAuth<any>(`/api/v1/hubs/update`, data)
			await dispatch('_initAdmin', ['hubs', 'allStates'])
			return resp?.msg || []
		} catch (error: any) {
			// console.error(error);
			const msg = error.response?.data?.msg || error.response?.data || error.message
			// return []
			throw new Error(msg)
		}
	},

	// // //? GET MODULE
	// async _listModules({ state, dispatch }: any, project: any) {
	//   console.log('_listModules');
	//   // try {
	//   //   const config = await dispatch("_config")
	//   //   const resp = await axios.get(env.apiUrl + `/api/v1/modules/list`, config)
	//   //   return resp.data.modules
	//   // } catch (error:any) {
	//   //   console.error(error);
	//   //   const msg = error.response?.data?.msg || error.response?.data || error.message
	//   //   return {}
	//   // }
	// },

	//! NEW CHART API
	//! NEW CHART API
	//! NEW CHART API
	// async _listModuleRecords({ state, dispatch }: any, modulId: any) {
	// 	try {
	// 		const config = await dispatch('_config')
	// 		const resp = await axios.get(env.apiUrl + `/api/v2/modules/records/${modulId}`, config)
	// 		return resp.data?.data || {}
	// 	} catch (error: any) {
	// 		console.error(error)
	// 		const msg = error.response?.data?.msg || error.response?.data || error.message

	// 		return []
	// 	}
	// },
	// async _listModuleDeepRecords({ state, dispatch }: any, data: any) {
	// 	try {
	// 		console.log('_listModuleDeepRecords', data)
	// 		const config = await dispatch('_config')
	// 		const resp = await axios.get(env.apiUrl + `/api/v2/modules/deep/${data.modulSerial}/${data.tsFrom}/${data.tsTo}`, config)
	// 		return resp.data?.data || {}
	// 	} catch (error: any) {
	// 		console.error(error)
	// 		const msg = error.response?.data?.msg || error.response?.data || error.message

	// 		return []
	// 	}
	// },

	//? GET MODULE'S DATA
	async _listModuleData({ state, dispatch }: any, modulId: any) {
		try {
			// const config = await dispatch('_config')
			// const resp = await axios.get(env.apiUrl + `/api/v1/modules/data/${modulId}`, config)
			// return resp.data || []
			const resp = await http.getAuth<any>(`/api/v1/modules/data/${modulId}`)
			return resp || []
		} catch (error: any) {
			console.error(error)
			const msg = error.response?.data?.msg || error.response?.data || error.message
			µUtils.µ_error(msg)
			return []
		}
	},

	//? GET MODULE'S CHART DATA V2
	async _fetchChartData({ state, dispatch }: any, modulId: any) {
		try {
			// const config = await dispatch('_config')
			// const resp = await axios.get(env.apiUrl + `/api/v2/modules/logs/${modulId}`, config)
			// return resp.data || []
			const resp = await http.getAuth<any>(`/api/v2/modules/logs/${modulId}`)
			return resp || []
		} catch (error: any) {
			console.error(error)
			const msg = error.response?.data?.msg || error.response?.data || error.message
			µUtils.µ_error(msg)
			return []
		}
	},
	//? GET MODULE'S CHART DATA V2 / timearea
	async _fetchChartTimearea(
		{ state, dispatch }: any,
		data: { modulId: any; from: string | number; to: string | number },
	) {
		try {
			// console.log({ data })
			// // timearea/:modulid/:start/:end
			// const config = await dispatch('_config')
			// const resp = await axios.get(
			// 	env.apiUrl + `/api/v2/modules/timearea/${data.modulId}/${data.from}/${data.to}`,
			// 	config,
			// )
			// return resp.data || []
			const resp = await http.getAuth<any>(`/api/v2/modules/timearea/${data.modulId}/${data.from}/${data.to}`)
			return resp || []
		} catch (error: any) {
			console.error(error)
			const msg = error.response?.data?.msg || error.response?.data || error.message
			µUtils.µ_error(msg)
			return []
		}
	},

	async _updateModule({ state, dispatch }: any, data: any) {
		try {
			// const config = await dispatch('_config')
			// const headers = { ...config.headers, hubids: data.hubids }
			// const resp = await axios.post(env.apiUrl + `/api/v1/modules/update`, data, { headers })
			// // console.log(resp.data);
			// await dispatch('_initAdmin', ['allStates', 'modules'])
			// return resp.data?.msg || []
			const resp = await http.postAuth<any>(`/api/v1/modules/update`, data, {
				headers: { hubids: data.hubids },
			})
			await dispatch('_initAdmin', ['allStates', 'modules'])
			return resp?.msg || []
		} catch (error: any) {
			// console.error(error);
			const msg = error.response?.data?.msg || error.response?.data || error.message
			// return []
			throw new Error(msg)
		}
	},

	async _deleteLogFromModule({ state, dispatch }: any, data: any) {
		console.log('_deleteLogFromModule', data)
		try {
			// const config = await dispatch('_config')
			// const resp = await axios.post(env.apiUrl + `/api/v1/modules/deletelog`, data, config)
			// // await dispatch("_initAdmin", ['modules'])
			// return resp.data?.msg || []
			const resp = await http.postAuth<any>(`/api/v1/modules/deletelog`, data)
			await dispatch('_initAdmin', ['modules'])
			return resp?.msg || []
		} catch (error: any) {
			console.error(error)
			const msg = error.response?.data?.msg || error.response?.data || error.message
			throw new Error(msg)
		}
	},
	async _updateLogFromModule({ state, dispatch }: any, data: any) {
		console.log('_updateLogFromModule', data)
		try {
			// const config = await dispatch('_config')
			// const resp = await axios.post(env.apiUrl + `/api/v1/modules/updatelog`, data, config)
			// // await dispatch("_initAdmin", ['modules'])
			// return resp.data?.msg || []
			const resp = await http.postAuth<any>(`/api/v1/modules/updatelog`, data)
			await dispatch('_initAdmin', ['modules'])
			return resp?.msg || []
		} catch (error: any) {
			console.error(error)
			const msg = error.response?.data?.msg || error.response?.data || error.message
			throw new Error(msg)
		}
	},

	async _downloadHubCsvData({ state, dispatch }: any, data: any) {
		// console.log('_downloadHubCsvData', data)
		const { hubSerial, graphId, from, to, format, original } = data
		try {
			// const resp = await axios.get(
			// 	env.apiUrl + `/api/v1/export/${format}/hubs/${hubSerial || graphId}/${from}/${to}/${original}`,
			// 	await dispatch('_config'),
			// )
			const resp = await http.getAuth<any>(
				`/api/v1/export/${format}/hubs/${hubSerial || graphId}/${from}/${to}/${original}`,
			)
			// await dispatch("_initAdmin", ['modules'])
			// return resp.data?.msg || []
			// console.log(resp.data)
			let content = ''
			if (format == 'csv') content = 'data:text/csv;charset=utf-8,' + resp.data
			if (format == 'json') content = 'data:application/json;charset=utf-8,' + JSON.stringify(resp.data)
			if (format == 'tsv') content = 'data:text/tsv;charset=utf-8,' + resp.data
			// if (format == 'semicolon-csv') content = "data:text/csv;charset=utf-8," + resp.data

			const encodedUri = encodeURI(content)
			console.log(format)
			console.log(encodedUri)
			console.log(content)
			setTimeout(() => {
				const dlink: any = document.createElement('a')
				dlink.href = encodedUri
				dlink.download = `data-${hubSerial}-${from}-${to}.${format}`
				dlink.onclick = function (e: any) {
					const that = this
					setTimeout(function () {
						window.URL.revokeObjectURL(that.href)
					}, 3333)
				}
				dlink.click()
				dlink.remove()
			}, 250)

			return {}
		} catch (error: any) {
			const msg = error.response?.data?.msg || error.response?.data || error.message
			throw new Error(msg)
		}
	},
}

export default actions
